import { TOGGLE_MODAL } from '../actions';

export const modalReducer = (state = null, action) => {
    if (action.type === TOGGLE_MODAL) {
        return !state ? action.payload :  null;
    }
    return state;
}